import apiClient from './api/client';
import type { Notification, ReportVideoIssueDto } from '@/interfaces';

export const notificationService = {
  async reportVideoIssue(data: ReportVideoIssueDto): Promise<Notification> {
    const response = await apiClient.post('/notifications/report-video-issue', data);
    return response.data.data;
  },

  async getAll(): Promise<Notification[]> {
    const response = await apiClient.get('/notifications');
    return response.data.data;
  },

  async reportComment(commentId: number, reason?: string): Promise<void> {
    await apiClient.post(`/battle-video-comments/${commentId}/report`, {
      data: { reason },
    });
  },

  async resolveCommentReport(
    notificationId: number,
    action: 'dismiss' | 'remove',
  ): Promise<void> {
    await apiClient.post(
      `/battle-video-comments/reports/${notificationId}/resolve`,
      { data: { action } },
    );
  },

  async getMyNotifications(): Promise<Notification[]> {
    const response = await apiClient.get('/notifications/me');
    return response.data.data;
  },

  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data.data.count;
  },

  async markAsRead(id: number): Promise<Notification> {
    const response = await apiClient.patch(`/notifications/${id}/mark-as-read`);
    return response.data.data;
  },

  async markAllAsRead(): Promise<void> {
    await apiClient.patch('/notifications/mark-all-as-read');
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/notifications/${id}`);
  },
};

